import React, { useEffect, useRef } from 'react';

const PageHero = ({ title, subtitle, breadcrumbs, backgroundImage }) => {
    // Page hero with static background


    return (
        <section className="relative h-[100svh] min-h-[550px] md:min-h-[650px] overflow-hidden">
            {/* Background */}
            <div className="absolute inset-0">
                {backgroundImage ? (
                    <img
                        src={backgroundImage}
                        alt=""
                        className="absolute inset-0 w-full h-full object-cover brightness-125 contrast-105"
                    />
                ) : (
                    <img
                        src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&h=1080&fit=crop&q=100"
                        alt="Default hero"
                        className="absolute inset-0 w-full h-full object-cover brightness-125 contrast-105"
                    />
                )}
                {/* Lighter overlay for better visibility */}
                <div className="absolute inset-0 bg-gradient-to-r from-black/25 via-transparent to-black/15" />
            </div>

            {/* Content */}
            <div className="relative z-10 h-full flex flex-col justify-center pt-[100px] md:pt-[80px]">
                <div className="max-w-7xl mx-auto px-4 w-full">
                    {/* Breadcrumbs */}
                    {breadcrumbs && (
                        <nav className="mb-4 text-sm">
                            <ol className="flex items-center space-x-2 text-white/70">
                                {breadcrumbs.map((crumb, index) => (
                                    <li key={index} className="flex items-center">
                                        {index > 0 && <span className="mx-2">/</span>}
                                        {crumb.link ? (
                                            <a href={crumb.link} className="hover:text-white transition-colors">
                                                {crumb.label}
                                            </a>
                                        ) : (
                                            <span className="text-white">{crumb.label}</span>
                                        )}
                                    </li>
                                ))}
                            </ol>
                        </nav>
                    )}

                    {/* Title */}
                    <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mb-2" style={{ textShadow: '2px 2px 6px rgba(0,0,0,0.7)' }}>
                        {title}
                    </h1>

                    {/* Subtitle */}
                    {subtitle && (
                        <p className="text-lg md:text-xl text-white max-w-2xl font-medium" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.6)' }}>
                            {subtitle}
                        </p>
                    )}
                </div>
            </div>
        </section>
    );
};

export default PageHero;
